import type { FeatureFlag } from '~/utils/isFeatureEnabled'
import type { ConnectionRequest } from '~/features/Home/enums'

export type Statistics = {
  resolved_chats: number
  patients: number
  lpus_uses_mt_link: number
  medcard_course_medals: number
  patients_with_medcard: number
}

export type FeedbackFormDto = {
  form_type: ConnectionRequest
  name: string
  phone: string
}

export const HomeApi = {
  getFeatureFlags: () => {
    return $apiFetch<FeatureFlag>('/feature_flags/')
  },
  getStatistics: () => {
    return $apiFetch<Statistics>('/statistics/')
  },
  sendFeedback: (payload: FeedbackFormDto) => {
    return $apiFetch('/send_feedback_form/', {
      method: 'POST',
      body: payload,
    })
  },
}
